import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsPipeModule } from '@rx-applications/shared/utils';
import { FormFieldViewModeComponent, MandatoryDirectiveModule, RxInputModule, RxSelectModule } from '@roomex/rx-components';
import { ReactiveFormsModule } from '@angular/forms';
import { FormElement } from '@rx-applications/shared/utils-forms';
import { SelectOption } from '@rx-applications/shared/ui';
import { TranslocoDirective, TranslocoPipe } from '@ngneat/transloco';
import { GuestbookForm, LoyaltyProgram } from '@rx-applications/clientsite-guestbook/utils';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { map, Observable } from 'rxjs';
import { GuestbookLoggerService, LoyaltyService } from '@rx-applications/clientsite-guestbook/data-access';

@Component({
  selector: 'rx-applications-loyalty-form',
  standalone: true,
  imports: [
    CommonModule,
    MandatoryDirectiveModule,
    ReactiveFormsModule,
    RxInputModule,
    RxSelectModule,
    AsPipeModule,
    TranslocoPipe,
    TranslocoDirective,
    FormFieldViewModeComponent,
  ],
  templateUrl: './loyalty-form.component.html',
  styleUrls: ['./loyalty-form.component.scss'],
  providers: [translationProvider],
})
export class LoyaltyFormComponent extends FormElement implements OnInit, OnDestroy {
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  @Input() compact = false;
  @Input() borderBottom = false;
  @Input() removeFormOnDestroy = true;

  #loyaltyService: LoyaltyService = inject(LoyaltyService);
  #loggerService: GuestbookLoggerService = inject(GuestbookLoggerService);

  loyaltyPrograms$: Observable<SelectOption[]> = this.#loyaltyService.loyaltyPrograms$.pipe(
    map((loyaltyPrograms: LoyaltyProgram[]) =>
      loyaltyPrograms.map(({ id, name }) => ({
        label: name,
        value: id,
      }))
    )
  );

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.formSectionName) {
      this.add(GuestbookForm.LoyaltyCard);
    }
  }

  setLoyaltyProgramName({ label }: SelectOption): void {
    this.getControl('loyaltyProgramName').setValue(label);
    this.#loggerService.loyaltyProgramSelected({ LoyaltyProgram: label });
  }

  override ngOnDestroy(): void {
    if (this.removeFormOnDestroy) {
      super.ngOnDestroy();
    }
  }
}
